var _rect, _path, _path2, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEditOutline = function SvgEditOutline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "Edit-icon",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1609 -1304C-1609 -1359.23 -1564.23 -1404 -1509 -1404H30517C30572.2 -1404 30617 -1359.23 30617 -1304V10566C30617 10621.2 30572.2 10666 30517 10666H-1509C-1564.23 10666 -1609 10621.2 -1609 10566V-1304Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1509 -1403H30517V-1405H-1509V-1403ZM30616 -1304V10566H30618V-1304H30616ZM30517 10665H-1509V10667H30517V10665ZM-1608 10566V-1304H-1610V10566H-1608ZM-1509 10665C-1563.68 10665 -1608 10620.7 -1608 10566H-1610C-1610 10621.8 -1564.78 10667 -1509 10667V10665ZM30616 10566C30616 10620.7 30571.7 10665 30517 10665V10667C30572.8 10667 30618 10621.8 30618 10566H30616ZM30517 -1403C30571.7 -1403 30616 -1358.68 30616 -1304H30618C30618 -1359.78 30572.8 -1405 30517 -1405V-1403ZM-1509 -1405C-1564.78 -1405 -1610 -1359.78 -1610 -1304H-1608C-1608 -1358.68 -1563.68 -1403 -1509 -1403V-1405Z",
    fill: "black",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1500,
    height: 900,
    transform: "translate(-1285 -351)",
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1397_6495)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1041,
    y: -299,
    width: 1238,
    height: 830,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1397_6495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1025 -53H181V459C181 461.209 179.209 463 177 463H-1021C-1023.21 463 -1025 461.209 -1025 459V-53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1206,
    height: 774.641,
    transform: "translate(-1025 -53)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -22.25,
    y: -10.4395,
    width: 203,
    height: 42.3856,
    stroke: "#EAECF0",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.81616 16.9434H19.1475V18.1813H1.81616V16.9434ZM16.3002 6.42074C16.7954 5.92555 16.7954 5.18278 16.3002 4.6876L14.0719 2.45928C13.5767 1.9641 12.834 1.9641 12.3388 2.45928L3.05412 11.7439V15.7054H7.01558L16.3002 6.42074ZM13.2054 3.32585L15.4337 5.55417L13.5767 7.4111L11.3484 5.18278L13.2054 3.32585ZM4.29207 14.4674V12.2391L10.4819 6.04935L12.7102 8.27767L6.52039 14.4674H4.29207Z",
    fill: "#667085"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-1025 -53H181V459C181 461.209 179.209 463 177 463H-1021C-1023.21 463 -1025 461.209 -1025 459V-53Z",
    stroke: "#DADADA",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1397_6495"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1041,
    y: -299,
    width: 1238,
    height: 830,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1397_6495"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1025 -53H181V459C181 461.209 179.209 463 177 463H-1021C-1023.21 463 -1025 461.209 -1025 459V-53Z",
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEditOutline);
export default ForwardRef;